/* eslint semi:0 */
import { registerUtils } from '../application/nm'
import { create as makeEmptyObj } from './object'

export function filter(iterable, predicateFn) {
  return [...iterable].filter(predicateFn)
}

function makeSet(iterable) {
  return new Set(iterable)
}

export function intersection(...iterables) {
  return iterables.reduce(
    (acc, iterable) => makeSet(filter(iterable, m => acc.has(m))),
    makeSet(iterables[0])
  )
}

export function union(...iterables) {
  return makeSet(iterables.reduce((acc, iterable) => [...acc, ...iterable], []))
}

// based on http://www.2ality.com/2015/01/es6-set-operations.html
const set = Object.assign(makeEmptyObj(), {
  union,
  filter,
  intersection,
})

registerUtils({ set })



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/set.js